<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
    >
    </List>
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'

export default {
  name: 'NetworkMembers',
  data() {
    return {
      loading: false,
      header: [
        {
          text: 'global.hostname',
          value: 'hostname',
        },
        {
          text: 'global.cpuCores',
          value: 'total_cpu',
        },
        {
          text: 'global.ramMB',
          value: 'total_ram',
        },
        {
          text: 'global.usedCpu',
          value: 'used_cpu',
        },
        {
          text: 'global.usedRam',
          value: 'used_ram',
        },
        {
          text: 'global.ipAddress',
          value: 'ip_addr',
        },
        {
          text: 'global.isAlive',
          value: 'is_alive',
        },
      ],
      data: [],
      pagination: {},
      meta: {},
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `iaas/network-members?datacenterNode=${
        this.$route.params.id
      }&fields=total_cpu,total_ram,used_cpu,used_ram,management_url,ip_addr&position=id|DESC&page=${
        current_page ? current_page : 1
      }`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
}
</script>
